// specBook.ts — Heritage Spec Book read + edit methods.
//
// The Spec Book is the company-wide product standard (migration 0056; the
// active version is the red-penned Heritage Build Standard from 0106), global /
// not project-scoped. The read surface is the whole book in one payload; the
// edit surface is the audited subsection PATCH (W9-5 paper, Option C —
// edit-in-place). See workers/core-os/src/routes/spec_book.ts.

import { request } from './request'

export interface SpecSubsection {
  id: string
  title: string
  body: string
  brand_model: string | null
  flag: string | null
  flag_note: string | null
}

export interface SpecSection {
  id: string
  section_number: number
  title: string
  subsections: SpecSubsection[]
}

export interface SpecBookResponse {
  ok: true
  version: {
    id: string
    version_label: string
    effective_date: string
    notes: string | null
  } | null
  section_count: number
  subsection_count: number
  flagged_count: number
  sections: SpecSection[]
}

// Fields the subsection editor may change. Omitted keys are left untouched;
// `null` on brand_model / flag / flag_note clears them (flag=null also clears
// the note — the "resolve a pending update" path).
export interface SpecSubsectionPatch {
  title?: string
  body?: string
  brand_model?: string | null
  flag?: string | null
  flag_note?: string | null
}

export interface SpecSubsectionPatchResponse {
  ok: true
  id: string
  updated: string[]
  request_id: string
}

export const specBookApi = {
  get: () => request<SpecBookResponse>('/api/spec-book'),
  updateSubsection: (id: string, patch: SpecSubsectionPatch) =>
    request<SpecSubsectionPatchResponse>(
      `/api/spec-book/subsections/${encodeURIComponent(id)}`,
      { method: 'PATCH', body: JSON.stringify(patch) },
    ),
}
